import { Button, Row } from "antd";
import DocumentList from "../DocumentList";
import AdminDocumentList from "../DocumentList/AdminDocumentList";

type DocumentTemplatesPanelProps = {
  mode: "tenant" | "admin";
  groupId: string;
  documents: any[];
  handleDeleteDocument: (id: string) => void;
  onGenerateDocuments?: () => void;
};

const DocumentTemplatesPanel: React.FC<DocumentTemplatesPanelProps> = ({
  mode,
  groupId,
  documents,
  handleDeleteDocument,
  onGenerateDocuments,
}) => (
  <>
    {mode === "admin" && onGenerateDocuments && (
      <Row style={{ marginBottom: 16 }}>
        <Button onClick={onGenerateDocuments}>Generate Documents</Button>
      </Row>
    )}
    <Row gutter={[12, 12]} className="document-container">
      {mode === "admin" ? (
        <AdminDocumentList
          groupId={groupId}
          documents={documents}
          handleDeleteDocument={handleDeleteDocument}
        />
      ) : (
        <DocumentList
          groupId={groupId}
          documents={documents}
          handleDeleteDocument={handleDeleteDocument}
        />
      )}
    </Row>
  </>
);

export default DocumentTemplatesPanel;
